module.exports = __webpack_public_path__ + "static/applemusiclogo-d03dc812c94a0a1c0dd6eb6727daa1b3.png";